import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/canyon-lake")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Canyon Lake, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Canyon Lake & Comal County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Canyon Lake, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Canyon Lake and Comal County.",
      keywords: "awnings Canyon Lake, awning company Canyon Lake, custom awnings Canyon Lake, sail shades Canyon Lake, patio covers Canyon Lake, pergola covers Canyon Lake, metal awnings Canyon Lake, canvas awnings Canyon Lake, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Canyon Lake", "Comal County"),
  }),
  component: () => <CityHomePage city="Canyon Lake" region="Comal County" />,
});
